import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AwarenessRoute = ({ children, orderData, orderLoading }) => {
  const { t } = useTranslation();
  const loading = orderLoading;
  const error = !orderData && !orderLoading ? 'No order data' : null;

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">{t('awarenessRoute.loadingError')}</h2>
          <p className="text-gray-600">{t('awarenessRoute.cannotVerifyAccess')}</p>
        </div>
      </div>
    );
  }

  // Controlla se Awareness è abilitato nell'ordine corrente
  const isAwarenessEnabled = orderData?.awareness_enabled;

  if (!isAwarenessEnabled) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">{t('awarenessRoute.accessDenied')}</h2>
          <p className="text-gray-600 mb-4">{t('awarenessRoute.moduleNotEnabled')}</p>
          <p className="text-sm text-gray-500">{t('awarenessRoute.contactReseller')}</p>
        </div>
      </div>
    );
  }

  return children;
};

export default AwarenessRoute;